/**
 * Groups an array into smaller chunks.
 *
 * @param array - An array to group into smaller arrays.
 * @param chunkSize - The maximum number of elements in an array.
 * @returns An array grouped into smaller arrays.
 */
export const chunkArray = (array, chunkSize = 4) => {
    return array.reduce((resultArray, item, index) => {
        const chunkIndex = Math.floor(index / chunkSize);
        if (!resultArray[chunkIndex]) {
            resultArray[chunkIndex] = []; // start a new chunk
        }
        resultArray[chunkIndex].push(item);
        return resultArray;
    }, []);
};
//# sourceMappingURL=chunkArray.js.map